import * as React from "react";
import classNames from "classnames";

import { Alarm } from "../../models";
import { AlarmComponent } from "./AlarmComponent";
import classes from "./AlarmsList.module.scss";

interface IProps {
	alarms: Alarm[];
	active?: boolean;
}

export const AlarmsList = ({ alarms, active }: IProps): JSX.Element => (
	<div className={classNames(classes.alarmsList, active ? classes.alarmsList__activeAlarms : "")}>
		<div className={classes.alarmsList__column}>
			{alarms.map(alarm => (
				<div className={classes.alarmsList__item} key={`${alarm.sensor}${alarm.timestamp}`}>
					<AlarmComponent alarm={alarm} />
				</div>
			))}
		</div>
	</div>
);

export const activeAlarmsPopupTrigger = (
	<div className={classes.popup__activeAlarms}>
    Active alarms
	</div>
);

export const clearedAlarmsPopupTrigger = (
	<div className={classes.popup__alarms}>
    Cleared alarms
	</div>
);
